import { ArticleVersionsDialogState, DialogsState } from '@/store/state/DialogsState';
import { Mutations } from '@/store/mutations';

export const dialogsMutations = {
  [Mutations.SET_SHOW_ARTICLE_VERSIONS_DIALOG](state: DialogsState, newState: ArticleVersionsDialogState) {
    state.articleVersionsDialog = newState;
  },
};
